import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getToolStorageList } from "../../Thunks/HeyTraderThunks";
import { ToolType } from "../../Types/HeyTraderTypes/Tools/ToolType";

interface ToolStorageSliceState {
  loader: boolean;
  toolStorages: ToolType[];
  errorDisplay: string | null;
}

const initialState: ToolStorageSliceState = {
  loader: false,
  toolStorages: [],
  errorDisplay: '',
}

const toolStorageslice = createSlice({
  name: 'toolStorages',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder
      .addCase(getToolStorageList.rejected, (state, action) => {
        state.loader = false;
        state.errorDisplay = action.error.message!;
      })
      .addCase(getToolStorageList.pending, state => {
        state.loader = true;
        state.errorDisplay = null;
      })
      .addCase(getToolStorageList.fulfilled, (state, action: PayloadAction<ToolType[]>) => {
        state.loader = false;
        state.toolStorages = action.payload;
      })
  }
})

export default toolStorageslice.reducer

